// extracted by mini-css-extract-plugin
export default {"toggle":"hotSellingToggle_toggle__xtWFb","active":"hotSellingToggle_active__Km94r","label":"hotSellingToggle_label__nY4PS","knob":"hotSellingToggle_knob__eIKk0"};